import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { FormAlertType } from '../../../../../core/constants/constants';
import { WorkflowService } from '../../../../../core/services/workflow.service';
import { FormBuilder, NonNullableFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin.service';


@Component({
	selector: 'app-cmcom-dialog',
	templateUrl: './cmcom-dialog.component.html',
	styleUrls: ['./cmcom-dialog.component.scss'],
})

export class CMcomDialogComponent implements OnInit, OnDestroy {
	constructor(@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<CMcomDialogComponent>,
		private translateService: TranslateService,
		private domSanitizer: DomSanitizer,
		private matIconRegistry: MatIconRegistry,
		private workflowService: WorkflowService,
		private formBuilder: NonNullableFormBuilder,
		private router: Router,
		private adminService: AdminService) {
		this.matIconRegistry.addSvgIcon(
			'trash_can',
			this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/trash.svg")
		);
	}

	connectionForm = this.formBuilder.group({
		name: ['', [Validators.required]],
		accountId: ['', [Validators.required]],
		productToken: ['', [Validators.required]]
	});
	showFormAlert: boolean = false;
	alertMsg: string = "";
	alertMsgStyle: any = { 'margin': '32px 32px 0' };
	alertType: FormAlertType;

	ngOnInit() {
		this.adminService.getAccountTags(this.data.account.accountId).then(tags => {
			if (tags && tags.CMcom) {
				if (tags.CMcom.enabled == true && tags.CMcom.connectionId !== undefined) {
					this.dialogRef.close({
						setupComplete: true,
					});
					this.router.navigate(['accounts', this.data.account.accountId, 'integrations', 'social', 'cmcom']);
				}
			}
		})
	}

	onCancel() {
		this.dialogRef.close();
	}

	ngOnDestroy() {
	}

	onSave() {
		this.showFormAlert = false;
		return this.workflowService.saveCMcomConnector({
			name: this.connectionForm.controls['name'].value.trim(),
			productToken: this.connectionForm.controls['productToken'].value.trim(),
			cmcomAccountId: this.connectionForm.controls['accountId'].value.trim()
		}).then(done => {
			//do the rest of the account set up
			this.data.product.service.completeSetup(this.data.account.accountId, done.connectionId, this.connectionForm.controls['accountId'].value.trim())
				.then(account => {
					let result =
					{
						setupComplete: true,
					}
					this.dialogRef.close(result);
					this.router.navigate(['accounts', this.data.account.accountId, 'integrations', 'social', 'cmcom']);
				}).catch(err => {
					this.alertMsg = this.translateService.instant('integrations.cmcom.generic-error');
					this.alertType = FormAlertType.ERROR;
					this.showFormAlert = true;
				});
		})
			.catch(err => {
				this.alertMsg = this.translateService.instant('integrations.cmcom.generic-error');
				this.alertType = FormAlertType.ERROR;
				this.showFormAlert = true;
			});
	}

  onRemoveIntegration() {
    console.log("Remove the integration - when successful, close the dialog");
    let result =
    {
      remove: true
    }
    this.dialogRef.close(result);
  }
}
